import moment, { Moment } from 'moment'
import * as Yup from 'yup'

export const getStartDateValidationError = (
  value: string | null | undefined,
  earliestStartDate: string | null | undefined,
  isAbTestWeekZeroRemovalVariant: boolean
): string | undefined => {
  if (!value) return undefined // missing values are reported by required()

  const date = moment(value, 'YYYY-MM-DD', true)
  if (!date.isValid()) return 'Invalid date'

  if (!earliestStartDate) return 'Earliest allowed start date is not available'
  if (date.isBefore(moment(earliestStartDate))) {
    return `Start date cannot be earlier than ${moment(earliestStartDate).format('M/D/YYYY')}`
  }
  if (!isAbTestWeekZeroRemovalVariant && date.day() !== 1) return 'Start date must be a Monday'

  return undefined
}

export const isStartDateDisabled = (
  date: Moment,
  earliestStartDate: string | null | undefined,
  isAbTestWeekZeroRemovalVariant: boolean
) =>
  date == null ||
  getStartDateValidationError(date.format('YYYY-MM-DD'), earliestStartDate, isAbTestWeekZeroRemovalVariant) !==
    undefined

// Rejects manually typed dates the calendar would show as grayed out
export const programStartDateSchema = (
  earliestStartDate: string | null | undefined,
  isAbTestWeekZeroRemovalVariant: boolean
) =>
  Yup.string()
    .required()
    .test({
      name: 'is-selectable-start-date',
      test(value) {
        const error = getStartDateValidationError(value, earliestStartDate, isAbTestWeekZeroRemovalVariant)
        return error ? this.createError({ message: error }) : true
      },
    })

export const getProgramStartDateSuggestion = (
  earliestStartDate: string | null | undefined,
  isAbTestWeekZeroRemovalVariant: boolean
) => {
  if (isAbTestWeekZeroRemovalVariant && earliestStartDate) {
    return moment(earliestStartDate)
  }

  const nextMonday = moment().add(1, 'weeks').isoWeekday('Monday')

  return moment(nextMonday).diff(moment(), 'days') < 7 ? nextMonday.add(1, 'week') : nextMonday
}
